import { render, staticRenderFns } from "./TastingListItem.vue?vue&type=template&id=205667c5&"
import script from "./TastingListItem.vue?vue&type=script&lang=js&"
export * from "./TastingListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports